export default [
  {
    name: 'Error',
    path: '/errors-list',
    component: () => import('@/modules/errors/pages/Errors'),
    meta: {
      ability: [
        {
          resource: 'errors',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Error detail',
    path: '/errors-list/view/:id',
    component: () => import('@/modules/errors/pages/ErrorsDetails'),
    meta: {
      ability: [
        {
          resource: 'errors/:id',
          actions: ['read'],
        },
      ],
    },
  },
]
